import { Breadcrumbs, Grid, Link, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { path } from "../../../../constants/path";
import ContextSlotInPut from "../../components/ContextSlotInPut/ContextSlotInPut";
import { getTTSContextDetail } from "../../../../apis/TTS/context.api";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { createTTSSlot, removeTTSSlot } from "../../../../apis/TTS/slot.api";
import { NotifyConfirm } from "../../../../components/notify/Notify";

const TTSContextSlot = () => {
  let { id } = useParams();
  const [context, setContext] = useState({});

  useEffect(() => {
    if (id) {
      getTTSContextDetail(id, (result) => {
        setContext({ ...result });
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const addOrEdit = (slotList) => {
    const slotCreateData = {
      ttsContextId: context.id,
      slotList,
    };

    createTTSSlot(slotCreateData, (_) => {
      getTTSContextDetail(id, (result) => {
        setContext({ ...result });
      });
    });
  };

  const handleDeleteSlot = (slotDeleted) => {
    NotifyConfirm("warning", "Are you delete it ?", (result) => {
      if (result.isConfirmed) {
        const foundSlotIndex = context.slots.findIndex(
          (slot) => slot.id === slotDeleted.id
        );
        if (foundSlotIndex !== -1) {
          removeTTSSlot(slotDeleted.id);
          context.slots.splice(foundSlotIndex, 1);
          setContext((prev) => {
            return {
              ...prev,
              slots: [...context.slots],
            };
          });
        }
      }
    });
  };

  return (
    <div>
      <Breadcrumbs aria-label="breadcrumb">
        <Link underline="hover" color="inherit" href={`${path.ttsContext}`}>
          {`${context?.contextNamespace} - ${context?.contextName}`}
        </Link>
        <Typography color="text.primary">Config Slot</Typography>
      </Breadcrumbs>
      <div style={{ marginTop: "40px" }}>
        <Grid container>
          <Grid item xs={12} p={5}>
            <ContextSlotInPut
              addOrEdit={addOrEdit}
              contextSlots={context.slots || []}
              handleDeleteSlot={handleDeleteSlot}
            />
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default TTSContextSlot;
